import React, { useCallback } from 'react';
import {
    required,
    minLength,
    maxLength,
    minValue,
    maxValue,
    number,
    regex,
    email,
    choices, Button,
    Edit, SimpleForm, TextInput,ReferenceInput, SelectInput,
    DateInput, BooleanInput, NumberInput,FileInput, FileField,
    ImageInput, ImageField, SaveButton, Toolbar, DeleteButton,FormDataConsumer
} from 'react-admin';
import RichTextInput from 'ra-input-rich-text';
import { useForm } from 'react-final-form';
import CancelIcon from '@material-ui/icons/Cancel';
import SaveIcon from '@material-ui/icons/Save';
import * as apiClient from "../../common/apiClient";
import CreateToolbar from "../../CreateToolbar";
import { makeStyles } from '@material-ui/core/styles';
import { useStyles } from "../../formStyles";
import {Addressfields} from "./Addressfields";
const PostCreateToolbar = props => (
    
    <Toolbar {...props}>
        <SaveButton submitOnEnter={true}  onSave={props.onSave} />
        <Button
        variant="contained" color="primary"
        label="Back" size="medium"
        startIcon={<CancelIcon />}
        style={{marginLeft:"30px"}}
        onClick={props.onCancel}
        />
    </Toolbar>
);
const NomineeEdit = props => {
    const classes = useStyles({});
    
    const handleSubmit = (formdata) => {
        console.log(formdata);
        apiClient.updateRecord("customer-nominees", formdata).then(res => {
            console.log(res);
            props.onClose();
        }).catch(err => {
            console.log(err);
        });
        
        
    }
    return (
        <Edit {...props} id={props.record.id} resource="customer-nominees" redirect="false">
            <SimpleForm
                onSubmit={handleSubmit}
                
                toolbar={
                <PostCreateToolbar label="Save " onSave={handleSubmit} onClose={props.onClose}  onCancel={props.onCancel} 
                 />}
                variant="outlined">
                
            <TextInput source="name" label="Name" fullWidth={true}    validate={[required()]} formClassName={classes.one_4_input} />
            <TextInput source="shortName" label="Short Name"  fullWidth={true}   validate={[required()]} formClassName={classes.two_4_input} />
            
            
           
            <TextInput source="gender" label="Gender"  fullWidth={true}    formClassName={classes.three_4_input} />
            <DateInput source="dob" label="Dob"  fullWidth={true}   formClassName={classes.last_4_input} />
            <TextInput source="relation" label="Relation"  fullWidth={true}   validate={[required()]} formClassName={classes.one_three_input} />
            <TextInput multiline source="address1"  fullWidth={true}   label="Address 1" formClassName={classes.two_three_input} />
            <TextInput multiline source="address2"  fullWidth={true}   label="Address 2" formClassName={classes.last_three_input} />

            


            <FormDataConsumer fullWidth={true} >
              {formDataProps => (
                <Addressfields {...formDataProps} />
              )}
            </FormDataConsumer>
            <TextInput source="pin" label="Pincode"  fullWidth={true}   formClassName={classes.one_4_input} />
            <TextInput source="phone" label="Phone"  fullWidth={true}  formClassName={classes.two_4_input} />
            <TextInput source="mobile" label="Mobile"  fullWidth={true}   formClassName={classes.three_4_input} />
            <TextInput source="fax" label="Fax"   fullWidth={true}  formClassName={classes.last_4_input} />
            <TextInput source="email" label="Email"  fullWidth={true}   formClassName={classes.one_4_input} />


            <TextInput source="pan" label="Pan"  fullWidth={true}  formClassName={classes.two_4_input} />
            <TextInput source="website" label="Website"   fullWidth={true}  formClassName={classes.three_4_input} />
             <TextInput source="education" label="Education"  fullWidth={true}   formClassName={classes.last_4_input} />
            

          <ReferenceInput  perPage={2000}  label="Status" fullWidth={true}  source="statusId" reference="lookups" formClassName={classes.one_4_input} sort={{ field: 'name', order: 'ASC' }} filter={{ type: 'RO' }} >
              <SelectInput optionText="name"/>
          </ReferenceInput> 
          <BooleanInput source="isActive" label="Is Active" initialValue={true} formClassName={classes.two_4_input} /> 

               
            </SimpleForm>
        </Edit>
    );
}
export default NomineeEdit;